import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    darkMode: true,
    userProgress: {
      theory: {
        intro: 0,
        why: 0,
        blueocean: 0,
        cases: 0,
        algorithm: 0,
        strategy: 0
      },
      practice: {
        account: 0,
        keywords: 0,
        content: 0,
        publish: 0,
        analysis: 0,
        advanced: 0
      }
    },
    completedExercises: []
  },
  mutations: {
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode
    },
    updateProgress(state, { module, section, progress }) {
      state.userProgress[module][section] = progress
    },
    completeExercise(state, exerciseId) {
      if (!state.completedExercises.includes(exerciseId)) {
        state.completedExercises.push(exerciseId)
      }
    }
  },
  actions: {
    toggleTheme({ commit }) {
      commit('toggleDarkMode')
    },
    updateLearningProgress({ commit }, payload) {
      commit('updateProgress', payload)
    },
    markExerciseComplete({ commit }, exerciseId) {
      commit('completeExercise', exerciseId)
    }
  },
  getters: {
    isDarkMode: state => state.darkMode,
    getTheoryProgress: state => state.userProgress.theory,
    getPracticeProgress: state => state.userProgress.practice,
    getOverallProgress: state => {
      const theory = Object.values(state.userProgress.theory)
      const practice = Object.values(state.userProgress.practice)
      const total = [...theory, ...practice]
      return total.reduce((acc, curr) => acc + curr, 0) / total.length
    },
    isExerciseCompleted: state => exerciseId => {
      return state.completedExercises.includes(exerciseId)
    }
  }
})
